import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import 'rxjs/Rx';

@Component({
    selector: 'my-page-layout-confirm-dialog',
    styles: [],
    template: require('./confirmdialog.component.html')
})

export class PageLayoutConfirmDialogComponent {    
    ProductReleaseNo: string;
    TitleDescription: string;
    constructor(public dialogRef: MdDialogRef<PageLayoutConfirmDialogComponent>,        
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.ProductReleaseNo = this.data.ProductReleaseNo;
        if (this.data.Status == "Active")
            this.TitleDescription = "Once Release #" + this.ProductReleaseNo + " is approved then you can active the Release.";
        else if (this.data.Status == "Edit")
            this.TitleDescription = "Once Release #" + this.ProductReleaseNo + " is approved then you can't edit the Release.";
        else if (this.data.Status == "Add")
            this.TitleDescription = "You can't add new release because there is already one pending release in queue";
        else if (this.data.Status == "DBVersionMSG")
            this.TitleDescription = "You can't active this release because DBVersion value always greater than or equal to stable release";
    }

    onCancel(): void {
        this.dialogRef.close(true);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/confirm-dialog/confirmdialog.component.ts